import { z } from 'zod';

export const cognismCredentialsSchema = z.object({
  apiToken: z.string().min(1, { message: 'Please provide an API token.' }),
});

export type CognismCredentials = z.infer<typeof cognismCredentialsSchema>;
